import {theme as vioTheme} from '../vio'

const {fonts: vioFonts} = vioTheme

export const fonts = {
  ...vioFonts
}
